export default __webpack_public_path__ + "static/media/my_journey_part1_2.d2420655.png";